import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { REDUCER_NAME } from '../reducer';
import { REDUCER_NAME as CURRENT_REDUCER } from './reducer';
import ChartCommon from '../../../../common/mixChart/MixChart';
import Const from './Const';
import { withComponentId } from './../../../../common/ComponentIdContext';
import { THEMES } from './../../../../../configs/LayoutConfig';
import { getDataFollowKeyByDot } from '../../../../helpers/Common';

class Chart extends React.Component {
  render() {
    const {
      width,
      theme,
      investData: { valueInvestChart, isFetching },
    } = this.props;
    const listTickValue = valueInvestChart.map(item =>
      getDataFollowKeyByDot(item, 'timeRange'),
    );

    return (
      <ChartCommon
        isLoading={isFetching}
        configChart={
          theme === THEMES.DARK ? Const.configChart : Const.configChartLight
        }
        data={valueInvestChart}
        xTickValues={listTickValue}
        width={width}
        ratio={window.devicePixelRatio}
        tickFormat={d => {
          return d;
        }}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    i18n: state.i18n,
    theme: state.theme,
    component: state[REDUCER_NAME].component,
    listValue: state[REDUCER_NAME].listValue,
    listChart: state[REDUCER_NAME].listChart,
    listTickValue: state[REDUCER_NAME].listTickValue,

    investData: state[CURRENT_REDUCER].investData,
  };
};

Chart.propTypes = {
  component: PropTypes.object,
  listChart: PropTypes.array,
};

Chart.defaultProps = {
  component: {},
  listTickValue: [],
};

export default compose(
  withComponentId,
  connect(mapStateToProps),
)(Chart);
